import React from 'react'
import { Image } from '@everlane/media'
import Button from '@everlane/button'
import classNames from 'classnames'

import Modal from 'base/react/components/modal'
import CloseIcon from 'base/components/layout/close_icon'

const SignupSuccessModal = ({ onRequestClose }) => {
  const closeIcon = (
    <CloseIcon
      handleClose={onRequestClose}
      className={classNames('new-user-modal__close-button', 'new-user-modal__close-button--white')}
    />
  )

  return (
    <Modal
      onRequestClose={onRequestClose}
      closeIcon={closeIcon}
      width={800}
      minHeight={0}
      containerClass="new-user-modal-modal-v2"
    >
      <div className={classNames('new-user-modal-content', 'new-user-modal-v2')}>
        <div className="new-user-modal__form">
          <div className="new-user-modal__heading">
            <span className="new-user-modal__title new-user-modal__title__success">
              You’re all set.
            </span>

            <div className="new-user-modal__copy">
              Your 10% discount is valid for 1 year <br /> after signup, and will automatically
              apply to <br /> your total at checkout.
            </div>
          </div>
          <Button
            type="button"
            className="flat-button--full-width signup-success-button"
            onClick={onRequestClose}
            variant="rectangle"
            dark
          >
            Start Shopping
          </Button>
        </div>
        <Image src={'i/d6b432e4_bf90.jpg'} className="new-user-modal__image" />
      </div>
    </Modal>
  )
}

export default SignupSuccessModal
